// src/store/slices/chatSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Send push/email notification when receiver is offline
export const sendChatNotification = createAsyncThunk(
  "chat/sendNotification",
  async (payload, { rejectWithValue }) => {
    try {
      await agent.post(API.SEND_CHAT_MSG, payload);
      return { success: true };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to send notification");
    }
  }
);

export const fetchUserInfo = createAsyncThunk(
  "user/fetchUserInfo",

  async (userId, { rejectWithValue }) => {

    try {

      const response = await agent.get(
        `${API.GETUSERDATA}/${userId}`
      );

      return response?.data?.data || {};

    } catch (error) {

      return rejectWithValue(
        error?.response?.data ||
        error?.message ||
        "Failed to fetch user info"
      );
    }
  }
);

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    chats: [],
    currentUser: {},
    roomKey: null,
    newMessage: "",
    isTyping: false,
    loading: false,
    error: null,
  },
  reducers: {
    setChats(state, action) {
      state.chats = action.payload;
    },
    addChatMessage(state, action) {
      state.chats.push(action.payload);
    },
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setRoomKey(state, action) {
      state.roomKey = action.payload;
    },
    setNewMessage(state, action) {
      state.newMessage = action.payload;
    },
    clearChatState(state) {
      state.chats = [];
      state.currentUser = {};
      state.roomKey = null;
      state.newMessage = "";
    },
  },
  extraReducers: (builder) => {

    builder

      .addCase(fetchUserInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload;
      })

      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(sendChatNotification.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  setChats,
  addChatMessage,
  setCurrentUser,
  setRoomKey,
  setNewMessage,
  clearChatState,
} = chatSlice.actions;

export default chatSlice.reducer;